import { Z as m } from "../index-BywkImj3.mjs";
import { c as T, p as D } from "../common-query-param-schema-CaKw7HAh.mjs";
import { z as L } from "../index-DGl1HeGK.mjs";
import { getArrayCookie as U, parseLoginUserDetailsCookie as v, parseAdbContextCookie as J } from "../auth/index.mjs";
import { l as z, b as H, a as V, c as F } from "../constants-DRbnCqET.mjs";
import { g as K, a as A } from "../language-BmpVHS7x.mjs";
import { c as Q, w as Z } from "../logger-BBmc3cJn.mjs";
import { B as O } from "../index-zeJwKglS.mjs";
const R = (r) => !!r && typeof r == "object" && "statusCode" in r, y = (r, e, s = {}) => ({
  statusCode: r,
  body: e ? JSON.stringify(e) : void 0,
  headers: {
    "Content-Type": "application/json",
    "Cache-Control": "no-cache",
    ...s
  }
});
class C extends Error {
  constructor(e, s) {
    super(e), this.code = s;
  }
}
class p extends C {
  constructor(e, s) {
    super(e, m.BAD_REQUEST), this.reason = s;
  }
}
class ie extends C {
  constructor(e) {
    super(e, m.INTERNAL);
  }
}
class B extends C {
  constructor(e) {
    super(e, m.UNAUTHORIZED);
  }
}
async function M(r) {
  const { envName: e, preview: s, verifySecret: t, logger: c = console } = r, i = new URL(`https://${e}.endpoint-directory.srv.smart.com`);
  if (s && i.searchParams.set("preview", "true"), c.debug(
    {
      envName: e,
      preview: s
    },
    `Fetching endpoint directory from ${i.href}`
  ), !t)
    throw new Error("Missing verify secret.");
  const d = await fetch(i.href, {
    headers: { [t.headerName]: t.headerValue }
  });
  if (!d.ok)
    throw Error(
      `Could not fetch endpoint directory (${d.status} ${d.statusText})`
    );
  return d.json();
}
const _ = async (r, e) => {
  const s = typeof e == "function" ? e : typeof r.mock == "string" ? e[r.mock] ?? e.default : e.default;
  if (!s)
    throw new p(
      "Bad request",
      `Mock '${r.mock}' not found. Available mocks: ${Object.keys(
        e
      ).join(", ")}`
    );
  const t = await s(r);
  return R(t) ? t : y(m.OK, t);
}, de = (r) => {
  if (!r)
    throw new Error("Missing body");
  try {
    const s = O.from(r, "base64").toString("utf-8");
    return JSON.parse(s.toString());
  } catch {
    return JSON.parse(r);
  }
}, G = (r) => {
  if (r)
    try {
      const s = O.from(r, "base64").toString("utf-8");
      return JSON.parse(s);
    } catch {
      try {
        return JSON.parse(r);
      } catch {
        return;
      }
    }
}, W = {
  accessToken: "mockedAccessToken",
  refreshToken: "mockedRefreshToken",
  idToken: "mockedIdToken",
  uid: "mockedUid",
  userId: "mockedUserId",
  ecomAccessToken: "mockedEcomAccessToken"
}, ue = (r, e) => {
  const {
    auth: s = !1,
    logger: t = Q(),
    schema: c,
    staticVerifySecret: i,
    fetchEndpoints: d = !0,
    cache: u,
    mockAuth: l = !1
  } = e ?? {};
  t.debug(e, "BFF handler initialized");
  const f = i ? JSON.parse(i) : void 0;
  return async (o, a) => {
    Z(o, a), t.debug(
      {
        event: o
      },
      "Event"
    );
    try {
      const n = o.headers.cookie ?? o.headers.Cookie ?? "", P = o.cookies ? U(
        o.cookies,
        z,
        H
      ) : v(n), q = o.cookies ? U(
        o.cookies,
        V,
        F
      ) : J(n);
      if (s && !P && !l)
        throw new B("User unauthorized");
      const k = (c != null && c.queryParams ? T.merge(c.queryParams) : T).safeParse(
        o.queryStringParameters ?? {}
      );
      if (!k.success)
        throw new p("Bad request", k.error.format());
      const S = (c != null && c.body ? c.body : L.object({})).safeParse(
        o != null && o.body ? G(o.body) ?? {} : {}
      );
      if (!S.success)
        throw new p("Bad request", S.error.format());
      const {
        envName: b,
        marketId: I,
        languageTag: g,
        preview: w,
        rotatingVerifySecret: N,
        mock: $,
        ...j
      } = k.data, x = d ? await M({
        envName: b,
        preview: w,
        verifySecret: N ?? f,
        logger: t
      }) : void 0, h = {
        envName: b,
        marketId: I,
        languageTag: g,
        language: K(g),
        countryCode: A(g),
        baseSiteId: `smart-${A(g)}`,
        preview: w,
        rotatingVerifySecret: N,
        user: l ? W : P,
        adb: q,
        endpoints: x,
        queryParams: j,
        body: S.data,
        aws: {
          context: a,
          event: o
        },
        mock: $
      };
      if (t.info(
        {
          event: h
        },
        "Handler"
      ), h.mock && b !== "prod" && (e != null && e.mock))
        return await _(h, e.mock);
      const E = await r(h);
      return R(E) ? E : y(m.OK, E, {
        "Cache-Control": w || !(u != null && u.ttl) ? "no-cache" : `max-age=${D(u.ttl, "s")}`
      });
    } catch (n) {
      return n instanceof p ? (t.warn(
        {
          err: n,
          event: o
        },
        "Bad Request"
      ), y(m.BAD_REQUEST, {
        code: n.code,
        message: n.message,
        reason: n.reason
      })) : n instanceof B ? (t.warn(
        {
          err: n,
          event: o
        },
        "Unauthorized"
      ), y(m.UNAUTHORIZED, {
        code: n.code,
        message: n.message
      })) : (t.error(
        {
          err: n,
          event: o
        },
        "Internal Server Error"
      ), y(m.INTERNAL, {
        code: 500,
        message: "Internal Server Error"
      }));
    }
  };
};
function fe(r, e) {
  return e.parse(r);
}
function me(r, e) {
  return e.safeParse(r);
}
async function le(r) {
  const { promises: e, debug: s, nodeUtil: t, debugDepth: c } = r, i = Object.keys(e), d = await Promise.allSettled(i.map((f) => e[f])), u = {}, l = {};
  for (let f = 0; f < i.length; f++) {
    const o = i[f], a = d[f];
    if ((a == null ? void 0 : a.status) === "rejected") {
      const n = o;
      u[n] = a.reason, s && console.debug(`Error in ${String(o)}`, a.reason);
    } else {
      const n = `${String(o)}Response`;
      l[n] = a == null ? void 0 : a.value, s && (t ? console.debug(
        `Success in ${String(o)}`,
        t.inspect(a == null ? void 0 : a.value, {
          showHidden: !1,
          depth: c ?? 2,
          colors: !0
        })
      ) : console.debug(`Success in ${String(o)}`, a == null ? void 0 : a.value));
    }
  }
  return {
    ...l,
    errors: Object.keys(u).length ? u : null
  };
}
export {
  p as BadRequest,
  ie as InternalServerError,
  C as LambdaError,
  B as Unauthorized,
  ue as bff,
  fe as coerceParams,
  me as coerceParamsSafe,
  T as commonQueryParamsSchema,
  y as formatResponse,
  le as handleAllSettledPromises,
  de as parseBody,
  G as safeParseBody
};
//# sourceMappingURL=index.mjs.map
